var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.text ? _c(_vm.resolver[_vm.level], {
    tag: "component",
    style: {
      color: _vm.color
    },
    domProps: {
      "innerHTML": _vm._s(_vm.textContent)
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };